export function carDetailToCarItem(detailData) {
	const carItem = { ...detailData.basic }
	if (detailData.photo) {
		carItem.appearances = detailData.photo.appearance.items
		carItem.interior = detailData.photo.interior.items
	}

	if (detailData.sell_programme) {
		carItem.price = detailData.sell_programme.sell_price
	}
	return carItem
}
